var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHouse = function SvgHouse(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 24,
    height: 24,
    viewBox: "0 0 409.6 409.6"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 100.265V409.6h119.465V77.865zm85.335 275.2h-51.2v-34.13h51.2zm0-68.265h-51.2v-34.135h51.2zm0-68.265h-51.2V204.8h51.2zm0-68.27h-51.2v-34.13h51.2zM153.6 0v409.6h256V48zM256 375.465h-51.2v-34.13H256zm0-68.265h-51.2v-34.135H256zm0-68.265h-51.2V204.8H256zm0-68.27h-51.2v-34.13H256zm0-68.265h-51.2V68.265H256zm102.4 273.065h-51.2v-34.13h51.2zm0-68.265h-51.2v-34.135h51.2zm0-68.265h-51.2V204.8h51.2zm0-68.27h-51.2v-34.13h51.2z"
  })));
};
export default SvgHouse;